import { GripVertical } from 'lucide-react'
import type { DraggableAttributes, DraggableSyntheticListeners } from '@dnd-kit/core'
import { cn } from '@/lib/utils'

interface StepDragHandleProps {
  /** Spread the dnd-kit listeners + attributes returned by `useSortable`. */
  listeners?: DraggableSyntheticListeners
  attributes?: DraggableAttributes
  /** Render disabled-looking when the level only has one item (drag is a no-op). */
  disabled?: boolean
  className?: string
}

/**
 * Phase 11a: drag handle for dnd-kit-powered step reordering. Hover-revealed on desktop; the
 * handle's container should pair {@code group} + {@code group-hover:opacity-100} on the row to
 * fade it in. Spread {@code listeners} and {@code attributes} from `useSortable`.
 */
export const StepDragHandle = ({
  listeners,
  attributes,
  disabled,
  className,
}: StepDragHandleProps) => (
  <button
    type="button"
    {...attributes}
    {...listeners}
    aria-label="Drag to reorder step"
    disabled={disabled}
    className={cn(
      'flex h-7 w-5 shrink-0 items-center justify-center rounded text-muted-foreground/60 transition-colors',
      'hover:bg-muted hover:text-muted-foreground focus-visible:bg-muted focus-visible:text-muted-foreground',
      'cursor-grab active:cursor-grabbing',
      'disabled:cursor-default disabled:opacity-30',
      className
    )}
  >
    <GripVertical className="h-4 w-4" aria-hidden />
  </button>
)
